import { UserRoles } from '@/models/User';

const hasAffiliateAccess = (roles: string[] = []): boolean => roles.includes(UserRoles.AFFILIATE_USER);

export default hasAffiliateAccess;
